<template>
  <div class="main-container">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AppMain"
}
</script>

<style lang="scss" scoped>

.main-container {
  flex: 1;
  padding: 80px 20px 20px;
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue